/* eslint-disable class-methods-use-this,@typescript-eslint/no-unused-vars */

import * as Yup from 'yup';
import { IFormDefinition } from '../formDefinitionInterface';
import { ISignUpPhoneNumberEntryForm } from './types';

export class SignUpPhoneNumberEntryFormDefinition implements IFormDefinition {
  phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  public validationSchema: any = Yup.object().shape({
    unconfirmedPhone: Yup.string()
      .required('Please enter a phone number')
      .matches(this.phoneRegExp, 'Phone number is not valid')
      .min(10, 'Phone number must be 10 digits')
      .max(10, 'Phone number must be 10 digits'),
  });

  public initialValues(dataOverride?: any): ISignUpPhoneNumberEntryForm {
    const values = {
      unconfirmedPhone: '',
    };
    return values;
  }

  public HUMANIZATION_MAP = {
    unconfirmedPhone: 'Phone number',
  };
}
